import { Bars } from "react-loader-spinner";

const SuspenseLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white animate-fadeIn">
      <div className="flex flex-col items-center gap-3">
        {/* Gradient Spinner */}
        <Bars
          height="50"
          width="50"
          color="#307bc4"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass="animate-pulse"
          visible={true}
        />

        {/* Loading text */}
        <span className="text-gray-600 text-sm font-medium tracking-wide animate-pulse">
          Loading...
        </span>
      </div>
    </div>
  );
};

export default SuspenseLoader;
